import * as React from 'react';
import { notification } from 'antd';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { IntlProps } from '../../';
import {
    alertDelete,
    AlertState,
    RootState,
    selectAlertState,
} from '../../modules';
import { getMessageByErrorCode } from '../../helpers/getMessageByErrorCode';
import { injectIntl } from 'react-intl';

interface ReduxProps {
    alert: AlertState;
}

interface DispatchProps {
    alertDelete: typeof alertDelete;
}

type Props = ReduxProps & DispatchProps & IntlProps;

const AlertComponent: React.FC<Props> = ({ alert }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (alert.alert) {
            const alertMessage = alert.alert.message;
            if (alert.alert.type === 'error') {
                notification.error({
                    message: getMessageByErrorCode(alert.alert.codeConfig as number),
                    description: alertMessage,
                    duration: 3,
                });
            } else if (alert.alert.type === 'success') {
                notification.success({
                    message: alertMessage[0], // message[0] for success message
                    description: alertMessage[1], // message[1] for success description
                    duration: 3,
                });
            }
        }
    }, [alert, dispatch]);

    return null;
};

const mapStateToProps = (state: RootState): ReduxProps => ({
    alert: selectAlertState(state),
});

const mapDispatchToProps = {
    alertDelete,
};

export const Alerts = connect(mapStateToProps, mapDispatchToProps)(injectIntl(AlertComponent));